export default __webpack_public_path__ + "static/media/coming soon copy.7ac4c5b1.jpg";